import React, {useEffect, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import EmployerService from "../../../services/EmployerService";
import Spinner from "reactjs-simple-spinner";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import isEmail from "validator/lib/isEmail";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import {MenuItem} from "@material-ui/core";


const EditEmployer = () => {

    const [emp, setEmployer] = useState({});
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [street, setStreet] = useState('');
    const [suburb, setSuburb] = useState('');
    const [city, setCity] = useState('');
    const [postal_address_street, setPostalAddressStreet] = useState('');
    const [postal_address_suburb, setPostalAddressSuburb] = useState('');
    const [postal_address_city, setPostalAddressCity] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [error, setError] = useState(false);
    //input error message
    const [nameError, setNameError] = useState(false);
    const [nameErrorMsg, setNameErrorMsg] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');
    const [contactError, setContactError] = useState(false);
    const [contactErrorMsg, setContactErrorMsg] = useState('');
    const [streetError, setStreetError] = useState(false);
    const [streetErrorMsg, setStreetErrorMsg] = useState('');
    const [suburbError, setSuburbError] = useState(false);
    const [suburbErrorMsg, setSuburbErrorMsg] = useState('');
    const [cityError, setCityError] = useState(false);
    const [cityErrorMsg, setCityErrorMsg] = useState('');
    const [postalSuburbError, setPostalSuburbError] = useState(false);
    const [postalSuburbErrorMsg, setPostalSuburbErrorMsg] = useState('');
    const [postalStreetError, setPostalStreetError] = useState(false);
    const [postalStreetErrorMsg, setPostalStreetErrorMsg] = useState('');
    const [postalCityError, setPostalCityError] = useState(false);
    const [postalCityErrorMsg, setPostalCityErrorMsg] = useState('');


    useEffect(() => {
        setLoading(true);
        const id = JSON.parse(localStorage.getItem('employerId'));
        EmployerService.getEmployerDetails(id).then(response => {
            console.log(response);
            setEmployer(response);
            setName(response.name)
            setEmail(response.email)
            setContactNumber(response.contact_number)
            setSuburb(response.suburb)
            setStreet(response.street)
            setCity(response.city)
            setPostalAddressSuburb(response.postal_address_suburb)
            setPostalAddressStreet(response.postal_address_street)
            setPostalAddressCity(response.postal_address_city)
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setLoading(false);
        });

    }, []);


    const handleChangeName = (e) => {
        console.log(e.target.value)
        setName(e.target.value);
    }
    const handleChangeEmail = (e) => {
        if (e.target.value === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (isEmail(e.target.value) === false) {
            console.log(emailError)
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        console.log(e.target.value)
        setEmail(e.target.value)
    }
    const handleChangeContactNumber = (e) => {
        if (e.target.value === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        if (e.target.value.length < 9) {
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        console.log(e.target.value)
        setContactNumber(e.target.value);
    }
    const handleChangeStreet = (e) => {
        console.log(e.target.value)
        setStreet(e.target.value);
    }
    const handleChangeSuburb = (e) => {
        console.log(e.target.value)
        setSuburb(e.target.value)
    }
    const handleChangeCity = (e) => {
        console.log(e.target.value)
        setCity(e.target.value);
    }
    const handleChangePostalAddressStreet = (e) => {
        console.log(e.target.value)
        setPostalAddressStreet(e.target.value);
    }
    const handleChangePostalAddressSuburb = (e) => {
        console.log(e.target.value)
        setPostalAddressSuburb(e.target.value)
    }
    const handleChangePostalAddressCity = (e) => {
        console.log(e.target.value)
        setPostalAddressCity(e.target.value)
    }

    const handleUpdate = (e) => {
        e.preventDefault();
        // if any field is empty don't submit
        if (name === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (email === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (!isEmail(email)) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
            setError(true);
            return;
        }
        if (contactNumber === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (street === '') {
            setStreetError(true)
            setStreetErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (suburb === '') {
            setSuburbError(true)
            setSuburbErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (city === '') {
            setCityError(true)
            setCityErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (postal_address_street === '') {
            setPostalStreetError(true)
            setPostalStreetErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (postal_address_suburb === '') {
            setPostalSuburbError(true)
            setPostalSuburbErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (postal_address_city === '') {
            setPostalCityError(true)
            setPostalCityErrorMsg('Field is required')
            setError(true);
            return;
        }
        //reset error messages
        setError(false)
        setEmailError(false);
        setNameError(false);
        setCityError(false);
        setContactError(false);
        setStreetError(false);
        setSuburbError(false);
        setPostalSuburbError(false);
        setPostalStreetError(false);
        setPostalCityError(false);
        setSubmitLoading(true);
        //call update endpoint
        let data = {
            'employerId': JSON.parse(localStorage.getItem('employerId')),
            'name': name,
            'email': email,
            'contact_number': contactNumber,
            'street': street,
            "suburb": suburb,
            'city': city,
            'postal_address_street': postal_address_street,
            'postal_address_suburb': postal_address_suburb,
            'postal_address_city': postal_address_city,
        }
        EmployerService.updateEmployer(data)
            .then(res => {
                console.log(res);
                if (res.status === 200 || res.status === 201) {
                    toast('Aggregator Updated Successfully', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setSubmitLoading(false);
                    console.log(res);
                } else {
                     toast.warning('Operation Failed', {
                         position: "top-center",
                         autoClose: 3000,
                         hideProgressBar: false,
                         closeOnClick: true,
                         pauseOnHover: true,
                         draggable: true,
                         progress: undefined,
                     });
                    setSubmitLoading(false);
                }

            })
            .catch(err => {
                toast.warning('Operation Failed', {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setSubmitLoading(false);
                console.log(err);
            })
    }


    return(
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard">
                                <i className="fa fa-home"/>&nbsp;Dashboard
                            </Link>
                             &nbsp;|&nbsp;
                            <Link to="/employers">
                                <a href> Aggregators </a>
                            </Link>   &nbsp;|&nbsp;
                            Edit Aggregator
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="card">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Getting Aggregator Details..."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {submitLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Updating Aggregator Details..."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && !submitLoading && (
                                        <form id="employerData" onSubmit={handleUpdate}>
                                            <div id="form-style">
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <TextField
                                                            error={nameError}
                                                            helperText={nameErrorMsg}
                                                            required
                                                            autoFocus
                                                            margin="dense"
                                                            label="Name"
                                                            type="text"
                                                            fullWidth
                                                            inputProps={{style: {textTransform: 'capitalize'}}}
                                                            value={name}
                                                            onChange={handleChangeName}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <TextField
                                                            error={emailError}
                                                            helperText={emailErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Email"
                                                            type="email"
                                                            fullWidth
                                                            inputProps={{style: {textTransform: 'lowercase'}}}
                                                            value={email}
                                                            onChange={handleChangeEmail}
                                                        />
                                                    </div>

                                                    <div className="form-group col-md-6">
                                                        <TextField
                                                            error={contactError}
                                                            helperText={contactErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Contact Number"
                                                            type="number"
                                                            fullWidth
                                                            value={contactNumber}
                                                            onChange={handleChangeContactNumber}
                                                            onInput={(e) => {
                                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                                                            }}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">
                                                                    +263
                                                                </InputAdornment>
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={streetError}
                                                            helperText={streetErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Street"
                                                            type="text"
                                                            fullWidth
                                                            value={street}
                                                            onChange={handleChangeStreet}
                                                        />
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={suburbError}
                                                            helperText={suburbErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Suburb"
                                                            type="text"
                                                            fullWidth
                                                            value={suburb}
                                                            onChange={handleChangeSuburb}
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={cityError}
                                                            helperText={cityErrorMsg}
                                                            onChange={handleChangeCity}
                                                            label="City"
                                                            select
                                                            fullWidth
                                                            required>
                                                            {city !== '' && (
                                                                <MenuItem selected={true} value={city}>
                                                                    {city}
                                                                </MenuItem>
                                                            )}
                                                            <MenuItem value disabled={true}>Select City</MenuItem>
                                                            <MenuItem value="Arcturus">Arcturus</MenuItem>
                                                            <MenuItem value="Banket">Banket</MenuItem>
                                                            <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                                                            <MenuItem value="Bindura">Bindura</MenuItem>
                                                            <MenuItem value="Buhera">Buhera</MenuItem>
                                                            <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                                                            <MenuItem value="Chegutu">Chegutu</MenuItem>
                                                            <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                                                            <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                                                            <MenuItem value="Chipinge">Chipinge</MenuItem>
                                                            <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                                                            <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                                                            <MenuItem value="Chivhu">Chivhu</MenuItem>
                                                            <MenuItem value="Darwendale">Darwendale</MenuItem>
                                                            <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                                                            <MenuItem value="Guruve">Guruve</MenuItem>
                                                            <MenuItem value="Gwanda">Gwanda</MenuItem>
                                                            <MenuItem value="Gweru">Gweru</MenuItem>
                                                            <MenuItem value="Harare">Harare</MenuItem>
                                                            <MenuItem value="Hwange">Hwange</MenuItem>
                                                            <MenuItem value="Kadoma">Kadoma</MenuItem>
                                                            <MenuItem value="Kariba">Kariba</MenuItem>
                                                            <MenuItem value="Karoi">Karoi</MenuItem>
                                                            <MenuItem value="Kezi">Kezi</MenuItem>
                                                            <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                                                            <MenuItem value="Lupane">Lupane</MenuItem>
                                                            <MenuItem value="Marondera">Marondera</MenuItem>
                                                            <MenuItem value="Masvingo">Masvingo</MenuItem>
                                                            <MenuItem value="Mazoe">Mazoe</MenuItem>
                                                            <MenuItem value="Mhangura">Mhangura</MenuItem>
                                                            <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                                                            <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                                                            <MenuItem value="Murehwa">Murehwa</MenuItem>
                                                            <MenuItem value="Mutare">Mutare</MenuItem>
                                                            <MenuItem value="Mutoko">Mutoko</MenuItem>
                                                            <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                                                            <MenuItem value="Norton">Norton</MenuItem>
                                                            <MenuItem value="Nyanga">Nyanga</MenuItem>
                                                            <MenuItem value="Plumtree">Plumtree</MenuItem>
                                                            <MenuItem value="Redcliff">Redcliff</MenuItem>
                                                            <MenuItem value="Rusape">Rusape</MenuItem>
                                                            <MenuItem value="Ruwa">Ruwa</MenuItem>
                                                            <MenuItem value="Sakubva">Sakubva</MenuItem>
                                                            <MenuItem value="Shamva">Shamva</MenuItem>
                                                            <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                                                            <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                                                            <MenuItem value="Zvishavane">Zvishavane</MenuItem>
                                                        </TextField>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={postalStreetError}
                                                            helperText={postalStreetErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="postal address street"
                                                            type="text"
                                                            fullWidth
                                                            value={postal_address_street}
                                                            onChange={handleChangePostalAddressStreet}
                                                        />
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={postalSuburbError}
                                                            helperText={postalSuburbErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="postal address suburb"
                                                            type="text"
                                                            fullWidth
                                                            value={postal_address_suburb}
                                                            onChange={handleChangePostalAddressSuburb}
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={postalCityError}
                                                            helperText={postalCityErrorMsg}
                                                            onChange={handleChangePostalAddressCity}
                                                            name="postal_address_city"
                                                            label="Postal Address City"
                                                            select
                                                            fullWidth
                                                            required>
                                                            {postal_address_city !== '' && (
                                                                <MenuItem selected={true} value={postal_address_city}>
                                                                    {postal_address_city}
                                                                </MenuItem>
                                                            )}
                                                            <MenuItem value disabled={true}>Select City</MenuItem>
                                                            <MenuItem value="Arcturus">Arcturus</MenuItem>
                                                            <MenuItem value="Banket">Banket</MenuItem>
                                                            <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                                                            <MenuItem value="Bindura">Bindura</MenuItem>
                                                            <MenuItem value="Buhera">Buhera</MenuItem>
                                                            <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                                                            <MenuItem value="Chegutu">Chegutu</MenuItem>
                                                            <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                                                            <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                                                            <MenuItem value="Chipinge">Chipinge</MenuItem>
                                                            <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                                                            <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                                                            <MenuItem value="Chivhu">Chivhu</MenuItem>
                                                            <MenuItem value="Darwendale">Darwendale</MenuItem>
                                                            <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                                                            <MenuItem value="Guruve">Guruve</MenuItem>
                                                            <MenuItem value="Gwanda">Gwanda</MenuItem>
                                                            <MenuItem value="Gweru">Gweru</MenuItem>
                                                            <MenuItem value="Harare">Harare</MenuItem>
                                                            <MenuItem value="Hwange">Hwange</MenuItem>
                                                            <MenuItem value="Kadoma">Kadoma</MenuItem>
                                                            <MenuItem value="Kariba">Kariba</MenuItem>
                                                            <MenuItem value="Karoi">Karoi</MenuItem>
                                                            <MenuItem value="Kezi">Kezi</MenuItem>
                                                            <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                                                            <MenuItem value="Lupane">Lupane</MenuItem>
                                                            <MenuItem value="Marondera">Marondera</MenuItem>
                                                            <MenuItem value="Masvingo">Masvingo</MenuItem>
                                                            <MenuItem value="Mazoe">Mazoe</MenuItem>
                                                            <MenuItem value="Mhangura">Mhangura</MenuItem>
                                                            <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                                                            <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                                                            <MenuItem value="Murehwa">Murehwa</MenuItem>
                                                            <MenuItem value="Mutare">Mutare</MenuItem>
                                                            <MenuItem value="Mutoko">Mutoko</MenuItem>
                                                            <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                                                            <MenuItem value="Norton">Norton</MenuItem>
                                                            <MenuItem value="Nyanga">Nyanga</MenuItem>
                                                            <MenuItem value="Plumtree">Plumtree</MenuItem>
                                                            <MenuItem value="Redcliff">Redcliff</MenuItem>
                                                            <MenuItem value="Rusape">Rusape</MenuItem>
                                                            <MenuItem value="Ruwa">Ruwa</MenuItem>
                                                            <MenuItem value="Sakubva">Sakubva</MenuItem>
                                                            <MenuItem value="Shamva">Shamva</MenuItem>
                                                            <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                                                            <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                                                            <MenuItem value="Zvishavane">Zvishavane</MenuItem>
                                                        </TextField>
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-md-12">
                                                        <Link to="/employers">
                                                            <button className="btn btn-info btn-sm">
                                                                <i className="fa fa-backward"/>&nbsp;&nbsp;Back
                                                            </button>
                                                        </Link>
                                                        <button
                                                            onClick={handleUpdate}
                                                            id="addEmployer"
                                                            className="btn btn-success btn-sm  ld-ext-right"
                                                        >
                                                            Save &nbsp;&nbsp;<i className="fa fa-send"/>&nbsp;&nbsp;
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                        </div>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditEmployer;
